export const USER_KANBAN_STYLE_PREFERENCE_KEY = 'work-items-view:kanban-style-preset';
